/** Derived on the server from subscriptions/orders; the list may grow (see WebPaymentsRepository). */
export type WebUserSubscriptionStatus = 'never' | 'active' | 'unsubscribed' | 'purchased';

/** One row of the users section, as returned by the GET_WEB_USERS websocket action. */
export interface WebUserRow {
    id: string;
    email: string | null;
    createdAt: string;
    hasPurchase: boolean;
    /** Last change of the payment status; null for users who never paid. */
    statusChangedAt: string | null;
    subscriptionStatus: WebUserSubscriptionStatus;
    /** Best-known language (browser > system > app); the server defaults it to 'en'. */
    language: string;
    source: string;
}

/** Keyset cursor — the last row of the page already loaded. */
export interface WebUsersCursor {
    createdAt: string;
    id: string;
}

/**
 * Both ranges are inclusive at the start and exclusive at the end, and are applied on the server:
 * `created` filters web_user.createdAt, `statusChanged` the latest payment status change.
 */
export interface WebUsersFilter {
    createdFrom: string | null;
    createdTo: string | null;
    statusChangedFrom: string | null;
    statusChangedTo: string | null;
}

export const emptyWebUsersFilter = (): WebUsersFilter => ({
  createdFrom: null,
  createdTo: null,
  statusChangedFrom: null,
  statusChangedTo: null,
});
